import { Navigate } from 'react-router-dom';
import { GuardProps } from '@/types';
import { useAppSelector } from '@/hooks/useAppSelector';
import Loader from '@/ui-component/Loader';
import { getUserHomePath, isStaffOrSupervisor } from '@/utils/role';

const StaffGuard = ({ children }: GuardProps) => {
    const { isInitializing } = useAppSelector(({ auth }) => auth);
    const { profile } = useAppSelector((state) => state.profile);

    if (isInitializing) {
        return <Loader />;
    }

    if (!isStaffOrSupervisor(profile)) {
        return <Navigate to={getUserHomePath(profile)} replace />;
    }

    return children;
};

export default StaffGuard;
